import React from 'react';
// components
import { Modal } from '@interstate/components/Modal';
import { Typography } from '@interstate/components/Typography';

export type PaymentRecalculatingDialogProps = {
    show: boolean;
    onHide(): void;
};

const PaymentRecalculatingDialog = ({ show, onHide }: PaymentRecalculatingDialogProps) => {
    const header = (
        <Typography variant="h4" tag="h4">
            Recalculating...
        </Typography>
    );

    return (
        <Modal
            size="small"
            data-testid="payment-recalculating-dialog"
            show={show}
            header={header}
            onHide={onHide}
            footer={{
                primary: {
                    buttonStyle: 'primary',
                    action: onHide,
                    label: 'Okay'
                }
            }}
        >
            <Typography variant="body-sm" tag="p">
                You have changes that are not calculated yet. Please review the updated calculations and click Save again.
            </Typography>
        </Modal>
    );
};

export default PaymentRecalculatingDialog;
